import React from "react";
import "./main-page.css";
import { Sidebar } from "../components/Sidebar";
import { MobilePannel } from "../components/MobilePannel";

const notice = [
    {
        date: "21.09.",
        day: "Неділя",
        text: "На сайті відбулося масштабне оновлення 8.1. Поспіши переглянути прем'єру оновлення, щоб бути в курсі усіх нововведень [тиць]"
    },
    {
        date: "22.09.",
        day: "Понеділок",
        text: "Навчання протягом тижня відбувається у дистанційному режимі"
    },
];

function MainPage () {
    return (
        <>
        <section className="screen">
            <div className="sidebar-box"><Sidebar /></div>
                <section className="content">
                    <h1 className="main-page-header">ПЛАНУЙ, НАВЧАЙСЯ, РОЗВИВАЙСЯ!</h1>
                    <div className="main-page-news">
                        <h2 className="main-page-title1">Оголошення</h2>
                        {notice.map((dateItem, dateIndex) => (
                            <div key={dateIndex} className={`main-page-box${dateIndex + 1}`}>
                                <div className={`main-page-box${dateIndex + 1}-header`}>
                                    <div className={`main-page-box${dateIndex + 1}-ind`}>{dateItem.date}</div>
                                    <h3 className={`main-page-box${dateIndex + 1}-name`}>{dateItem.day}</h3>
                                </div>
                                <p className={`main-page-box${dateIndex + 1}-text`}>{dateItem.text}</p>
                            </div>
                                ))}
                    </div>
                </section>
                <div className="mobile-pannel"><MobilePannel/></div>
            </section>
        </> 
    );
}

export default MainPage;